import React from 'react';
import PropTypes from 'prop-types';

import DocumentModal from './document_modal.jsx';
import DocumentDetails from '../details/document_details.jsx';
import EditDocumentForm from '../form/edit_document_form.jsx';

import DocumentStoreItem from '../../models/document_store_item';
import DocumentModalIds from '../../constants/document_modal_ids';
import { DocumentActions } from '../../reflux/document_store';

export default class ManageDocumentModal extends React.Component {

	static propTypes = {
		id: PropTypes.string,
		name: PropTypes.string,
		title: PropTypes.string,
		className: PropTypes.string,
		store: PropTypes.object
	};

	static defaultProps = {
		id: '',
		name: '',
		title: 'template.titles.manage',
		className: 'manage-document-modal',
		store: new DocumentStoreItem()
	};

	constructor(props) {
		super(props);
		this.dismissModal = this.dismissModal.bind(this);
	}

	get template() {
		return this.props.store.template;
	}

	get document() {
		return this.props.store.document;
	}

	componentDidMount(){
		setTimeout(() => { this.buttonCheckout() }, 1000);
	}

	buttonCheckout(){
		let btnCheckoutDoc = $('#btn-document-checkout');
		let btnCloseModal = $('.button-close-modal-document');

		btnCheckoutDoc.keydown((e) => {
			if(e.which === 9 || e.keyCode === 9 ){
				$('.h5-custom').focus();
				return false
			}
		});

		// btnCheckoutDoc.keypress((e) => {
		// 	if(e.which === 13 || e.keyCode === 13)
		// 		e.currentTarget.click();
		// });

		btnCloseModal.keydown((e) => {
			if(e.which === 13 || e.keyCode === 13)
				e.currentTarget.click();

			if(e.shiftKey && e.keyCode === 9)
				return false
		});
	}

	removeEventButtons(){
		$('#btn-document-checkout').off('keydown');
		$('#btn-document-checkout').off('keypress');
		$('.button-close-modal-document').off('keydown');
	}

	documentIsCheckedOut() {
		return this.document.checkedOut && !this.documentIsCheckedoutByOtherUser();
	}

	documentIsCheckedoutByOtherUser() {
		return this.props.store.documentIsCheckedoutByOtherUser;
	}

	documentIsReadonly() {
		return this.props.store.documentReadonly;
	}

	dismissModal() {
		window.setTimeout(() => {
			DocumentActions.changeDocumentCheckout(this.props.id, false);
		}, 500);
	}

	render() {
		const ContentComponent = this.documentIsCheckedOut() && !this.documentIsReadonly()
		? EditDocumentForm
		: DocumentDetails;

		return (<ContentComponent {...this.props} />);
	}
}
